import { Component } from 'react';

import './Home.css';

import { background_1, background_2, background_3, background_4, damps_white } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { push_history } from '@acri-tools/react-tools/utils/global';
import { ImageBackgroundSlider } from '../../components/ImageBackgroundSlider/ImageBackgroundSlider';
import { connect } from 'react-redux';
import GlobalStats from '../../components/GlobalStats/GlobalStats';
import { Helmet } from 'react-helmet';
import { PROD_URL, app_desciption } from '../../utils/config';

interface Props {
    // redux
    data: any,
}
interface State {
    selected_image: number
    loading_product_metric: boolean
    product_metric?: number
}

const BANNER_IMAGES = [
    background_1,
    background_2,
    background_3,
    background_4,
]

class Home extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
        this.state = {
            selected_image: 0,
            loading_product_metric: false,
            product_metric: 546872
        }
    }
    render() {
        return (
            <Page
                id="home"
                footer
                banner={{
                    customTitle:
                        <div className="home-banner">
                            <ImageBackgroundSlider images={BANNER_IMAGES} background_filter animated>
                                <div className="home-banner-content">
                                    <div className="home-banner-header">
                                        <img alt="banner image" className="home-banner-image" src={damps_white} />

                                        <div className="home-banner-subtitle">
                                            PDGS Data Archival, Management & Processing Services
                                        </div>

                                    </div>
                                </div>
                            </ImageBackgroundSlider>
                        </div>
                    ,
                    topBar: true
                }}
            >
                <Helmet>
                    <title>{'DAMPS Home'}</title>
                    <meta
                        name="description"
                        content={app_desciption}
                    />

                    {/* Protocole OpenGraph */}
                    <meta property="og:title" content={'DAMPS Home'} />
                    <meta property="og:description" content={app_desciption} />
                    <meta property="og:url" content={PROD_URL} />
                    <meta property="og:type" content="website" />
                </Helmet>

                <div className="page-content">
                    <div className="centered-content padding">
                        <h1 className="title-5">Overview</h1>
                        <p className="description">
                            The overarching objective of DAMPS is to deliver the
                            required  <span className="link" onClick={() => push_history('/services')}>services</span> to
                            the satisfaction of the ESA stakeholders and, beyond, of the users of the data with the following objectives:
                        </p>
                        <ul>
                            <li>Provision of a secure, reliable archive of EO data  </li>
                            <li>Optimal responsiveness to user needs  </li>
                            <li>Focus on data and on user needs  </li>
                            <li>Outsourcing of infrastructure & technology and a Service approach  </li>
                            <li>Synergies among activities within DAMPS  </li>
                            <li>Overall coherence with the other services which make up the end to end value chain of the data.</li>
                        </ul>

                        <br />
                        <br />
                        <br />
                        <div className="centered">
                            <div id="archive-content-button" className="custom-button green alt inline" onClick={() => { push_history('/archive-content') }}>
                                <i className="fas fa-share" /> CHECK THE ARCHIVE CONTENT
                            </div>
                        </div>
                    </div>
                    <div className="home-metrics-background">
                        <div className="centered-content padding">
                            <GlobalStats className="white" />
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
};


export default connect((state: any) => {
    return {
        data: state.data,
    }
})(Home);
